"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useOnOutsideClick = (containerRef, onOutsideClick, isEnabled = true) => {
    const onClick = (0, react_1.useCallback)((e) => {
        var _a;
        const target = e.target;
        if (!((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
            onOutsideClick();
        }
    }, [onOutsideClick, isEnabled]);
    (0, react_1.useEffect)(() => {
        if (isEnabled) {
            document.addEventListener('mousedown', onClick, true);
        }
        return () => {
            document.removeEventListener('mousedown', onClick, true);
        };
    }, [onClick, isEnabled]);
};
exports.default = useOnOutsideClick;
